
// @ts-nocheck


export const localeCodes =  [
  "fr-FR",
  "en-GB"
]

export const localeLoaders = {
  "fr-FR": [
    {
      key: "locale_fr_45FR_46json_dd52a70a",
      load: () => import("#nuxt-i18n/dd52a70a" /* webpackChunkName: "locale_fr_45FR_46json_dd52a70a" */),
      cache: true
    }
  ],
  "en-GB": [
    {
      key: "locale_en_45GB_46json_ab8d0470",
      load: () => import("#nuxt-i18n/ab8d0470" /* webpackChunkName: "locale_en_45GB_46json_ab8d0470" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "fr-FR",
      label: "Francais",
      icon: "cif:fr",
      abbr: "fr",
      files: [
        {
          path: "/src/i18n/locales/fr-FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en-GB",
      label: "English",
      icon: "cif:gb",
      abbr: "en",
      files: [
        {
          path: "/src/i18n/locales/en-GB.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "fr-FR",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "fr-FR",
    label: "Francais",
    icon: "cif:fr",
    abbr: "fr",
    files: [
      {
        path: "/src/i18n/locales/fr-FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en-GB",
    label: "English",
    icon: "cif:gb",
    abbr: "en",
    files: [
      {
        path: "/src/i18n/locales/en-GB.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/